import type { GqlFieldConfig } from "@/admin/FieldConfig.tsx";
import { ExactNumberFilter, HostPoolFilter, UnixDateRangeFilter } from "@/admin/filters.tsx";
import { HostPoolItem } from "@/admin/table_fields/HostPoolItem.tsx";
import { LocationItem } from "@/admin/table_fields/LocationItem.tsx";
import { SizeBytesGb } from "@/admin/table_fields/Sizes.tsx";
import { whenNotNull } from "@/admin/table_fields/whenNotNull.tsx";
import { CurrencyBalance } from "@/components/l10n/Currency.tsx";

export const currencyField = {
    render: whenNotNull(CurrencyBalance),
    align: "text-right",
} satisfies Partial<GqlFieldConfig<any, any, any>>;

export const numberField = {
    align: "text-right",
} satisfies Partial<GqlFieldConfig<any, any, any>>;

export const sizeBytesGbField = {
    render: SizeBytesGb,
    align: "text-right",
} satisfies Partial<GqlFieldConfig<any, any, any>>;

export const idField = {
    align: "text-right",
    copyable: true,
} satisfies Partial<GqlFieldConfig<any, any, any>>;

export const locationField = {
    id: "_location",
    title: "DC Location",
    render: whenNotNull(LocationItem),
} satisfies Partial<GqlFieldConfig<any, any, string | null>>;

export const hostPoolField = {
    id: "designated_pool_uuid",
    title: "Hypervisor pool",
    render: whenNotNull(HostPoolItem),
    filter: HostPoolFilter,
} satisfies Partial<GqlFieldConfig<any, any, string | null>>;

export const baIdField = {
    ...idField,
    id: "ba_id",
    title: "BA ID",
    filter: ExactNumberFilter,
} satisfies Partial<GqlFieldConfig<any, any, number | null>>;

export const userIdField = {
    ...idField,
    id: "user_id",
    title: "User ID",
    filter: ExactNumberFilter,
} satisfies Partial<GqlFieldConfig<any, any, number | null>>;

export const baField = {
    id: "billing_account",
    title: "Billing account",
};

export const createdAtField = {
    id: "created_at",
    title: "Created At",
    filter: UnixDateRangeFilter,
};
